import { render, staticRenderFns } from "./MessageAddTableUsers.vue?vue&type=template&id=07f474cf"
import script from "./MessageAddTableUsers.vue?vue&type=script&lang=js"
export * from "./MessageAddTableUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports